<template>
    <div class="container mortgage-calculator" :class="calculatorName">

		<div class="row justify-content-center calculator-header">
			<CalculatorHeader>
				<h2>Stamp Duty Calculator</h2>
				<p>To establish how much Stamp Duty you will need to pay, enter in your purchase details below.</p>
			</CalculatorHeader>
		</div>
		<div class="row justify-content-center calculator-body">
			<div class="col-md-10 col-xl-8">
				<form class="calculator-container">

					<div class="mt-3" @keyup="resetCalculation" @change="resetCalculation">
						<InputElement
							fieldText="Property purchase price:"
						>
							<InputTypeNumber currencyPlaceholder v-model="purchasePrice"/>
						</InputElement>

						<transition name="fade-x" mode="out-in">
							<div v-show="purchasePrice">
								<BooleanChoiceButtons
									@click="resetCalculation"
									fieldText="Is everyone involved in the purchase considered to be first time buyers?"
									buttonTextLeft="Yes"
									buttonTextRight="No"								
								>
									<template v-slot:left>
										<input @click="resetCalculation" type="radio" v-model="firsttimeBuyers" value="Yes">									
									</template>
									<template v-slot:right>
										<input @click="resetCalculation" type="radio" v-model="firsttimeBuyers" value="No">											
									</template>																
								</BooleanChoiceButtons>

								<transition name="fade-x" mode="out-in">
									<div key="Yes" v-if="firsttimeBuyers === 'Yes'">
										<BooleanChoiceButtons
											@click="resetCalculation"
											fieldText="Will the property be your main residence?"
											buttonTextLeft="Yes"
											buttonTextRight="No"								
										>
											<template v-slot:left>
												<input @click="resetCalculation" type="radio" v-model="mainResidence" value="Yes">									
											</template>
											<template v-slot:right>
												<input @click="resetCalculation" type="radio" v-model="mainResidence" value="No">									
											</template>																
										</BooleanChoiceButtons>
									</div>

									<div key="No" v-if="firsttimeBuyers === 'No'">
										<BooleanChoiceButtons
											fieldText="Is this property purchase a second home, additional property, or a buy to let property?"
											buttonTextLeft="Yes"
											buttonTextRight="No"								
										>
											<template v-slot:left>
												<input @click="resetCalculation" type="radio" v-model="secondProperty" value="Yes">									
											</template>
											<template v-slot:right>
												<input @click="resetCalculation" type="radio" v-model="secondProperty" value="No">									
											</template>																
										</BooleanChoiceButtons>
									</div>
								</transition>

								<transition name="fade-x" mode="out-in">
									<div class="row mt-5" v-if="(purchasePrice > 0 && mainResidence) || (purchasePrice > 0 && secondProperty )">
										<div class="col-md-6 col-lg-4">Why are you using the calculator today</div>
										<div class="col-md-6 col-lg-8 fcs-grid-long">
											<DropdownMenu :dropdownOptions="dropdownOptionsReason" v-model="calcReason1"></DropdownMenu>
										</div>
									</div>
								</transition>   

								

								<!-- <transition name="fade-x" mode="out-in">
									<InputElement
										v-if="(purchasePrice > 0 && mainResidence) || (purchasePrice > 0 && secondProperty )"
										fieldText="Name"
									>
										<input class="form-control calc-form-control" type="text" v-model="listName">
									</InputElement>
								</transition>

								<transition name="fade-x" mode="out-in">
									<InputElement
										v-if="(purchasePrice > 0 && mainResidence) || (purchasePrice > 0 && secondProperty )"
										fieldText="Email Address"
									>
										<input class="form-control calc-form-control" type="email" v-model="emailAddress">
									</InputElement>
								</transition>

								<transition name="fade-x" mode="out-in">
									<div class="row align-items-center" v-if="(purchasePrice > 0 && mainResidence) || (purchasePrice > 0 && secondProperty )">
										<div class="col-md-1">
											<input type="checkbox" id="privacy" v-model="consent" >
										</div>
										<div class="col-md-11">
											<label for="privacy">I consent to my personal information being processed in accordance with The Mortgage Centres <a href="/cookies-privacy-statement/" target="_blank">Privacy Policy</a></label>
										</div>
									</div>
								</transition> -->

								<transition name="scale-in" mode="out-in">
									<div
										v-if="(purchasePrice > 0 && mainResidence) || (purchasePrice > 0 && secondProperty )"
										class="text-center mt-5 mb-3"
									>
										<div class="btn calc-btn-secondary" @click="calculate">CALCULATE</div>
									</div>
								</transition>

							</div>
						</transition>
					</div>

					<transition name="fade-y" mode="out-in">
						<div v-if="calcCompleted && purchasePrice > 0" ref="resultsContainer">

							<ResultsContainer class="mt-5 mb-5 calc-results-box">
								<div class="mb-3 results-title" v-if="!isFieldInvalid">Based on a purchase price of:</div>
								<span class="fcs-price" v-if="!isFieldInvalid">£{{formatNumberOutput(purchasePrice)}}</span>
								<div class="mt-3 results-title" v-if="!isFieldInvalid">Your total stamp duty liability would be:</div>
								<span class="fcs-price" v-if="!isFieldInvalid">£{{stampDutyCalculationApril}}</span>
								<div class="mb-3 results-title" v-if="isFieldInvalid">Please select when you will be ready to move forward</div>
							</ResultsContainer>				

							<SubmissionForm :calculatorName="calculatorName" :calculatorData="collateMessageBody" />

						</div>
					</transition>						

				</form>				
			</div>

		</div>

    </div>
</template>

<script>
import BooleanChoiceButtons from '@/components/utilities/booleanChoiceButtons.vue'
import CalculatorHeader from '@/components/utilities/calculatorHeader.vue'
import InputElement from '@/components/utilities/inputElement.vue'
import InputTypeNumber from '@/components/utilities/inputTypeNumber.vue'
import ResultsContainer from '@/components/utilities/resultsContainer.vue'
import SubmissionForm from '@/components/utilities/submissionForm.vue'
import DropdownMenu from '@/components/utilities/dropdownMenu.vue'
import axios from "axios"

export default {
	components: {
		BooleanChoiceButtons,
		CalculatorHeader,
		InputElement,
		InputTypeNumber,
		ResultsContainer,
		DropdownMenu,
		SubmissionForm
	},	
    data() {
        return {
			calculatorName: 'stamp-duty-calculator',

			purchasePrice: 0,
			firsttimeBuyers: null,
			mainResidence: null,
			secondProperty: null,

			stampDutyValue: null,
            calcCompleted: false,

			calculatorReasonTitle: null,
			calculatorReasonResults: null,

			calcReason1: "",
            isFieldInvalid: false, // Validation state
			listName: "",
			emailAddress: "",
			consent: false,
          dropdownOptionsReason: [
            {value: "Please select an option", text: "Please select an option"},
            {value: "I'm ready to move forward with a mortgage", text: "I'm ready to move forward with a mortgage"},
            {
              value: "I'm not ready for a mortgage but am curious about what I could borrow",
              text: "I'm not ready for a mortgage but am curious about what I could borrow"
            },
            {
              value: "I'm starting to save for a house and want to know what to aim for",
              text: "I'm starting to save for a house and want to know what to aim for"
            },
            {
              value: "I need to understand a what I can afford before house shopping",
              text: "I need to understand a what I can afford before house shopping"
            },
          ],

          dropdownOptionsMove: [
            {value: "Please select an option", text: "Please select an option"},
            {value: "march", text: "Before 31st March"},
			{value: "april", text: "After 1st April"},
          ],
			submissionReason: {
				submitted: false,
				is_valid: false,
				confirmation_message: ''
			},
			submissionList: {
				submitted: false,
				is_valid: false,
				confirmation_message: ''
			},
            formErrors: [],
            gfid: 2, //Please check the Gravity Form for corresponding form id (staging and live may vary!)
			gfidlist: 7 //Please check the Gravity Form for corresponding form id (staging and live may vary!)
        }
		
    },
    methods: {
		validateField() {
            this.isFieldInvalid = false;
        },
        calculate() {
			this.validateField(); // Ensure the field is validated before proceeding
			this.stampDutyValue = this.stampDutyCalculationApril;
			this.calcCompleted = true;
			this.calculatorReasonTitle = this.removeHyphensToUpperCase(this.calculatorName);
			this.calculatorReasonResults = 
			`
			Why are you using the calculator today: ${this.calcReason1}
			`;
			this.$nextTick(() => {
                const resultsContainer = this.$refs.resultsContainer;

                if (resultsContainer) {
                    // Get the bounding rectangle of the element
                    const rect = resultsContainer.getBoundingClientRect();

                    // Calculate the target scroll position
                    const targetScrollPosition = window.scrollY + rect.top - 200;

                    // Scroll to the target position
                    window.scrollTo({
                        top: targetScrollPosition,
                        behavior: 'smooth'
                    });
                } else {
                    console.error('resultsContainer is undefined');
                }
            });
			
			var newReasonSubmission = new FormData();
			var newListSubmission = new FormData();

			newReasonSubmission.append("form_id", this.gfid); //Please check the Gravity Form form id (staging and live may vary!)
			newReasonSubmission.append("input_1", this.calculatorReasonTitle);
			newReasonSubmission.append("input_3", this.calculatorReasonResults);

			newListSubmission.append("form_id", this.gfidlist); //Please check the Gravity Form form id (staging and live may vary!)
			newListSubmission.append("input_1", this.listName);
			newListSubmission.append("input_3", this.emailAddress);
			newListSubmission.append("input_4.1", this.consent ? 'Yes' : 'No');

			this.postReasonSubmission(newReasonSubmission);
			this.postListSubmission(newListSubmission);

		},
		async postReasonSubmission(submissionReasonData) {
            try {

                const response = await axios.post(
                    `/wp-json/gf/v2/forms/`+ this.gfid + `/submissions`, //Please check the Gravity Form form id (staging and live may vary!)
                    submissionReasonData,
                    {
                        headers: {"Content-Type": "application/x-www-form-urlencoded"}
                    }
                );
                
                const submissionReason = response;
                // console.log(submission)

                if ( submissionReason.data.is_valid ) {
                    this.submissionReason.submitted = true;
                    this.submissionReason.is_valid = true;
                }
            } catch(error) {
                // console.log(error)
            }
        },
		async postListSubmission(submissionListData) {
            try {

                const response = await axios.post(
                    `/wp-json/gf/v2/forms/`+ this.gfidlist + `/submissions`, //Please check the Gravity Form form id (staging and live may vary!)
                    submissionListData,
                    {
                        headers: {"Content-Type": "application/x-www-form-urlencoded"}
                    }
                );
                
                const submissionList = response;
                // console.log(submission)

                if ( submissionList.data.is_valid ) {
                    this.submissionList.submitted = true;
                    this.submissionList.is_valid = true;
                }
            } catch(error) {
                // console.log(error)
            }
        },
		formatNumberOutput(number) {
			const newNumber = (new Intl.NumberFormat('en-GB').format(number))
			if ( newNumber === 'NaN' ) { return 0 } return newNumber
		},		
        removeHyphensToUpperCase(str) {
            return str.replace(/(-|^)([^-]?)/g, function(_, prep, letter) { return (prep && ' ') + letter.toUpperCase(); });
        },
		resetCalculation() {
			this.calcCompleted = false;
		},
		formatEmptyMessageFields(message){
			return message ? message : 'N/A'
		},
		standardStampDuty (propertyPrice, stampDuty) {
			if ( this.secondProperty == null || this.secondProperty === 'No') {
				switch (true) {
					case (propertyPrice < 250000):
						stampDuty = 0;
						break;
					case (propertyPrice >= 250000 && propertyPrice < 925000):
						stampDuty = ( propertyPrice - 250000 ) * 0.05;
						break; //5% on value over £250000
					case (propertyPrice >= 925000 && propertyPrice < 1500000):
						stampDuty = ( propertyPrice - 925000 ) * 0.1 + 33750;
						break; //10% on value over £925000
					case (propertyPrice >= 1500000):
						stampDuty = ( propertyPrice - 1500000 ) * 0.12 + 91250;
					break; //12% on value over £925000					
				}
				return stampDuty;
			} else {
				switch (true) {
					case (propertyPrice < 250000):
						stampDuty = propertyPrice * 0.05;
						break; //3% on property value
					case (propertyPrice >= 250000 && propertyPrice < 925000):
						stampDuty = ( propertyPrice - 250000 ) * 0.1 + 12500;
						break; //8% on value over £250000
					case (propertyPrice >= 925000 && propertyPrice < 1500000):
						stampDuty = ( propertyPrice - 925000 ) * 0.15 + 80000;
						break; //13% on value over £925000
					case (propertyPrice >= 1500000):
						stampDuty = ( propertyPrice - 1500000 ) * 0.17 + 166250;
					break; //15% on value over £925000					
				}
				return stampDuty;
			}
		},
		standardStampDutyApril (propertyPrice, stampDuty) {
			if ( this.secondProperty == null || this.secondProperty === 'No') {
				switch (true) {
					case (propertyPrice < 125000):
						stampDuty = 0;
						break;
					case (propertyPrice >= 125000 && propertyPrice < 250000):
						stampDuty = ( propertyPrice - 125000 ) * 0.02;
						break; //2% on value over £250000
					case (propertyPrice >= 250000 && propertyPrice < 925000):
						stampDuty = ( propertyPrice - 250000 ) * 0.05 + 2500;
						break; //5% on value over £925000
					case (propertyPrice >= 925000 && propertyPrice < 1500000):
						stampDuty = ( propertyPrice - 925000 ) * 0.1 + 36250;
						break; //5% on value over £925000
					case (propertyPrice >= 1500000):
						stampDuty = ( propertyPrice - 1500000 ) * 0.12 + 93750;
					break; //12% on value over £925000							
				}
				return stampDuty;
			} else {
				switch (true) {
					case (propertyPrice < 125000):
						stampDuty = propertyPrice * 0.05;
						break; //5% on value under £250000
					case (propertyPrice >= 125000 && propertyPrice < 250000):
						stampDuty = ( propertyPrice - 125000 ) * 0.07 + 6250;
						break; //7% on value over £250000
					case (propertyPrice >= 250000 && propertyPrice < 925000):
						stampDuty = ( propertyPrice - 250000 ) * 0.1 + 15000;
						break; //5% on value over £925000
					case (propertyPrice >= 925000 && propertyPrice < 1500000):
						stampDuty = ( propertyPrice - 925000 ) * 0.15 + 88750;
						break; //5% on value over £925000
					case (propertyPrice >= 1500000):
						stampDuty = ( propertyPrice - 1500000 ) * 0.17 + 196250;
					break; //12% on value over £925000							
				}
				return stampDuty;
			}
		},
    },	
    computed: {
        stampDutyCalculationApril() {
			let stampDuty = 0
			const propertyPrice = Number(this.purchasePrice)

			if ( this.firsttimeBuyers === 'Yes' ) {
				if ( this.mainResidence === 'Yes' ) {
					switch (true) {
						case (propertyPrice < 300000):
							stampDuty = 0;
							break;
						case (propertyPrice >= 300000 && propertyPrice <= 500000):
							stampDuty = ( propertyPrice - 300000 ) * 0.05;
							break; //5% on value over £300000
						case (propertyPrice > 500000):
							stampDuty = this.standardStampDutyApril(propertyPrice, stampDuty);
					}
				} else {
					stampDuty = this.standardStampDutyApril(propertyPrice, stampDuty);
				}
			} else {
				stampDuty = this.standardStampDutyApril(propertyPrice, stampDuty);
			}
			stampDuty = this.formatNumberOutput(stampDuty);
			return stampDuty;
		},
		collateMessageBody() {
			const calculatorData = {
				calculatorTitle: this.removeHyphensToUpperCase(this.calculatorName),
				calculatorResults: 
				`
				Property purchase price: £${parseInt(this.purchasePrice)}
				Is everyone involved in the purchase considered to be first time buyers? ${this.firsttimeBuyers}
				Will the property be your main residence? ${this.formatEmptyMessageFields(this.mainResidence)}
				Is this property purchase a second home, additional property, or a buy to let property? ${this.formatEmptyMessageFields(this.secondProperty)}
				Stamp Duty value: ${this.stampDutyValue}
				Why are you using the calculator today: ${this.calcReason1}
                `
			}
			return calculatorData;
		}
	}
}
</script>

<style lang="scss">
	@import './styles/calcs.scss';
</style>